// extracted by mini-css-extract-plugin
export var alertIcon = "_q8-0";